// import React from 'react';
// import { NRLogo } from './NRLogo';
// import { Facebook, Twitter, Instagram, Linkedin, ArrowUp } from 'lucide-react';
// import { FaWhatsapp } from "react-icons/fa";

// export const Footer = () => {
//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth'
//     });
//   };

//   const legalAreas = [
//     'القانون التجاري',
//     'قانون الأسرة',
//     'القانون الجنائي',
//     'قانون العقارات',
//     'قانون العمل',
//     'حقوق الملكية الفكرية'
//   ];

//   const quickLinks = [
//     { name: 'الرئيسية', href: '#hero' },
//     { name: 'خدماتنا', href: '#services' },
//     { name: 'عن المكتب', href: '#about' },
//     { name: 'فريق المحامين', href: '#attorneys' },
//     { name: 'آراء العملاء', href: '#testimonials' },
//     { name: 'اتصل بنا', href: '#contact' }
//   ];

//   return (
//     <footer className="bg-navy-900 text-white">
//       <div className="container mx-auto px-4 md:px-6 py-12">
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//           <div>
//             <div className="flex items-center mb-4">
//               <NRLogo color="#FFFFFF" />
//               <span className="mr-2 text-xl font-bold"
              
//               >  
              
              
// شركة ناصر الراجحي و رامي المطيري للمحاماة و الإستشارات القانونية 




//               </span>
//             </div>
//             <p className="text-gray-400 mb-6">
//               نقدم خدمات قانونية متميزة بأعلى مستويات الاحترافية والكفاءة لحماية حقوقك ومصالحك
//             </p>
//             <div className="flex space-x-4 rtl:space-x-reverse">
//               <a href="#" className="bg-navy-800 hover:bg-navy-600 text-white p-2 rounded-full transition-colors duration-300">
//                 <Facebook className="w-5 h-5" />
//               </a>
//               <a href="#" className="bg-navy-800 hover:bg-navy-600 text-white p-2 rounded-full transition-colors duration-300">
//                 <Twitter className="w-5 h-5" />
//               </a>
//               <a href="#" className="bg-navy-800 hover:bg-navy-600 text-white p-2 rounded-full transition-colors duration-300">
//                 <Instagram className="w-5 h-5" />
//               </a>
//               <a href="#" className="bg-navy-800 hover:bg-navy-600 text-white p-2 rounded-full transition-colors duration-300">
//                 <Linkedin className="w-5 h-5" />
//               </a>
//             </div>
//           </div>

//           <div>
//             <h3 className="text-lg font-bold mb-4 text-navy-300">مجالات ممارستنا</h3>
//             <ul className="space-y-2">
//               {legalAreas.map((area, index) => (
//                 <li key={index}>
//                   <a href="#services" className="text-gray-400 hover:text-navy-300 transition-colors duration-300">
//                     {area}
//                   </a>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           <div>
//             <h3 className="text-lg font-bold mb-4 text-navy-300">روابط سريعة</h3>
//             <ul className="space-y-2">
//               {quickLinks.map((link, index) => (
//                 <li key={index}>
//                   <a 
//                     href={link.href} 
//                     className="text-gray-400 hover:text-navy-300 transition-colors duration-300"
//                     onClick={(e) => {
//                       e.preventDefault();
//                       document.querySelector(link.href).scrollIntoView({ behavior: 'smooth' });
//                     }}
//                   >
//                     {link.name}
//                   </a>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           <div>
//             <h3 className="text-lg font-bold mb-4 text-navy-300">النشرة الإخبارية</h3>
//             <p className="text-gray-400 mb-4">
//               اشترك في نشرتنا الإخبارية للحصول على آخر الأخبار والمستجدات القانونية
//             </p>
//             <form className="flex">
//               <input 
//                 type="email" 
//                 placeholder="البريد الإلكتروني" 
//                 className="px-4 py-2 bg-navy-800 text-white border border-navy-700 rounded-r-lg focus:outline-none focus:ring-2 focus:ring-navy-600 w-full"
//               />
//               <button 
//                 type="submit" 
//                 className="bg-navy-600 hover:bg-navy-700 text-white px-4 py-2 rounded-l-lg transition-colors duration-300"
//               >
//                 اشتراك
//               </button>
//             </form>
//           </div>
//         </div>

//         <hr className="border-navy-800 my-8" />

//         <div className="flex flex-col md:flex-row justify-between items-center">
//           <p className="text-gray-400 text-center md:text-right mb-4 md:mb-0">
// © {new Date().getFullYear()} شركة ناصر الراجحي و رامي  المطيري للمحاماة و الإستشارات القانونية. جميع الحقوق محفوظة.          </p>
//           <div className="flex space-x-4 rtl:space-x-reverse">
//             <a href="#" className="text-gray-400 hover:text-navy-300 transition-colors duration-300">سياسة الخصوصية</a>
//             <a href="#" className="text-gray-400 hover:text-navy-300 transition-colors duration-300">الشروط والأحكام</a>
//           </div>
//         </div>
//       </div>

//       <button 
//         onClick={scrollToTop} 
//         className="bg-navy-600 hover:bg-navy-700 text-white p-3 rounded-full fixed bottom-6 left-6 shadow-lg transition-all duration-300 hover:transform hover:-translate-y-1"
//         aria-label="Scroll to top"
//       >
//         <ArrowUp className="w-5 h-5" />
//       </button>
//          <button 
//         onClick={() => {
//     window.open('https://wa.me/966595014100', '_blank');
//   }} 
//         className="bg-green-600 hover:bg-white text-white hover:text-green-600 p-3 rounded-full fixed bottom-6 right-6 shadow-lg transition-all duration-300 hover:transform hover:-translate-y-1"
//         aria-label="Scroll to top"
//       >
//         <FaWhatsapp  className="w-5 h-5" />
//       </button>
//     </footer>
//   );
// };



// import React from 'react';
// import { NRLogo } from './NRLogo';
// import { Facebook, Twitter, Instagram, Linkedin, ArrowUp } from 'lucide-react';
// import { FaWhatsapp } from "react-icons/fa";

// export const Footer = () => {
//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth'
//     });
//   };

//   // تحديث المجالات لتعكس الخدمات التجارية والاستثمارية الفعلية للشركة
//   const legalAreas = [
//     'القانون التجاري وحوكمة الشركات',
//     'تأسيس الشركات الكبرى والناشئة',
//     'المستثمرين الأجانب والإقامة المميزة',
//     'الدعاوى والنزاعات العقارية',
//     'الأنظمة العمالية وعقود العمل',
//     'الدعاوى الإدارية وديوان المظالم'
//   ];

//   const quickLinks = [
//     { name: 'الرئيسية', href: '#hero' },
//     { name: 'خدماتنا القانونية', href: '#services' },
//     { name: 'عن الشركة', href: '#about' },
//     { name: 'فريق العمل', href: '#attorneys' },
//     { name: 'اتصل بنا', href: '#contact' }
//   ];

//   // دالة تمرير ناعمة تأخذ بعين الاعتبار ارتفاع الهيدر
//   const handleScroll = (e, href) => {
//     e.preventDefault();
//     const target = document.querySelector(href);
//     if (target) {
//       const offset = document.querySelector('header')?.offsetHeight || 0;
//       window.scrollTo({
//         top: target.offsetTop - offset,
//         behavior: 'smooth'
//       });
//     }
//   };

//   return (
//     <footer className="bg-slate-950 text-white border-t border-slate-900" dir="rtl">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          
//           {/* العمود الأول: الشعار والوصف العام وقنوات التواصل */}
//           <div className="space-y-6">
//             <div className="flex items-center gap-3">
//               <NRLogo color="#fbbf24" /> {/* تفعيل لون الذهب الدافئ للشعار */}
//               <span className="text-lg font-bold leading-tight bg-gradient-to-r from-white to-slate-300 bg-clip-text text-transparent">  
//                 شركة ناصر الراجحي ورامي المطيري للمحاماة والاستشارات القانونية
//               </span>
//             </div>
//             <p className="text-slate-400 text-sm md:text-base font-light leading-relaxed">
//               شركة مهنية رائدة تقدم خدمات وقائية وقضائية متكاملة لحماية حقوقك ومصالح أعمالك بأعلى مستويات الموثوقية والحوكمة.
//             </p>
//             <div className="flex items-center gap-3 justify-start">
//               <a href="#" className="p-2.5 bg-slate-900 border border-slate-800 rounded-xl text-slate-400 hover:text-amber-400 hover:border-amber-500/20 transition-all duration-300" aria-label="Facebook">
//                 <Facebook className="w-4 h-4" />
//               </a>
//               <a href="#" className="p-2.5 bg-slate-900 border border-slate-800 rounded-xl text-slate-400 hover:text-amber-400 hover:border-amber-500/20 transition-all duration-300" aria-label="Twitter">
//                 <Twitter className="w-4 h-4" />
//               </a>
//               <a href="#" className="p-2.5 bg-slate-900 border border-slate-800 rounded-xl text-slate-400 hover:text-amber-400 hover:border-amber-500/20 transition-all duration-300" aria-label="Instagram">
//                 <Instagram className="w-4 h-4" />
//               </a>
//               <a href="#" className="p-2.5 bg-slate-900 border border-slate-800 rounded-xl text-slate-400 hover:text-amber-400 hover:border-amber-500/20 transition-all duration-300" aria-label="LinkedIn">
//                 <Linkedin className="w-4 h-4" />
//               </a>
//             </div>
//           </div>

//           {/* العمود الثاني: مجالات الممارسة المحدثة */}
//           <div>
//             <h3 className="text-base font-bold text-amber-400 mb-6 relative pb-2 after:content-[''] after:absolute after:bottom-0 after:right-0 after:w-8 after:h-0.5 after:bg-amber-500">
//               مجالات ممارستنا
//             </h3>
//             <ul className="space-y-3">
//               {legalAreas.map((area, index) => (
//                 <li key={index}>
//                   <a href="#services" onClick={(e) => handleScroll(e, '#services')} className="text-slate-400 hover:text-white transition-colors duration-200 text-sm font-light flex items-center gap-1.5">
//                     <span className="text-amber-500/40 text-xs">▪</span>
//                     {area}
//                   </a>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* العمود الثالث: الروابط السريعة للتنقل الداخلي */}
//           <div>
//             <h3 className="text-base font-bold text-amber-400 mb-6 relative pb-2 after:content-[''] after:absolute after:bottom-0 after:right-0 after:w-8 after:h-0.5 after:bg-amber-500">
//               روابط سريعة
//             </h3>
//             <ul className="space-y-3">
//               {quickLinks.map((link, index) => (
//                 <li key={index}>
//                   <a 
//                     href={link.href} 
//                     className="text-slate-400 hover:text-white transition-colors duration-200 text-sm font-light flex items-center gap-1.5"
//                     onClick={(e) => handleScroll(e, link.href)}
//                   >
//                     <span className="text-amber-500/40 text-xs">▪</span>
//                     {link.name}
//                   </a>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* العمود الرابع: الاشتراك البريدي المستحدث بنظام الـ Slate */}
//           <div>
//             <h3 className="text-base font-bold text-amber-400 mb-6 relative pb-2 after:content-[''] after:absolute after:bottom-0 after:right-0 after:w-8 after:h-0.5 after:bg-amber-500">
//               النشرة المستندية
//             </h3>
//             <p className="text-slate-400 text-sm font-light leading-relaxed mb-4">
//               اشترك في القائمة البريدية للمكتب لتلقي أحدث التحديثات والتحليلات للأنظمة واللوائح الصادرة حديثاً.
//             </p>
//             <form onSubmit={(e) => e.preventDefault()} className="flex gap-2">
//               <input 
//                 type="email" 
//                 placeholder="البريد الإلكتروني" 
//                 required
//                 className="px-4 py-2.5 bg-slate-900 text-white border border-slate-800 rounded-xl focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 w-full text-sm"
//               />
//               <button 
//                 type="submit" 
//                 className="bg-amber-500 hover:bg-amber-600 text-slate-950 font-bold px-4 rounded-xl transition-all duration-300 text-sm whitespace-nowrap"
//               >
//                 اشتراك
//               </button>
//             </form>
//           </div>
//         </div>

//         {/* الخط الفاصل السفلي الفخم */}
//         <div className="border-t border-slate-900 my-10"></div>

//         {/* الحقوق والروابط القانونية */}
//         <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs md:text-sm text-slate-500 font-light">
//           <p className="text-center md:text-right">
//             © {new Date().getFullYear()} شركة ناصر الراجحي ورامي المطيري للمحاماة والاستشارات القانونية. جميع الحقوق محفوظة.
//           </p>
//           <div className="flex gap-6">
//             <a href="#" className="hover:text-slate-300 transition-colors">سياسة الخصوصية</a>
//             <a href="#" className="hover:text-slate-300 transition-colors">الشروط والأحكام</a>
//           </div>
//         </div>
//       </div>

//       {/* زر العودة للأعلى العائم */}
//       <button 
//         onClick={scrollToTop} 
//         className="fixed bottom-6 left-6 z-40 bg-slate-900/80 hover:bg-amber-500 border border-slate-800 hover:border-amber-500 text-white hover:text-slate-950 p-3 rounded-xl shadow-2xl backdrop-blur-md transition-all duration-300 transform hover:-translate-y-1"
//         aria-label="Scroll to top"
//       >
//         <ArrowUp className="w-5 h-5" />
//       </button>

//       {/* زر الواتساب الرسمي العائم بتأثير متوهج مرن */}
//       <button 
//         onClick={() => window.open('https://wa.me/966595014100', '_blank')} 
//         className="fixed bottom-6 right-6 z-40 bg-emerald-600 hover:bg-emerald-500 text-white p-3 rounded-xl shadow-2xl shadow-emerald-600/20 backdrop-blur-md transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center"
//         aria-label="Contact via WhatsApp"
//       >
//         <FaWhatsapp className="w-5 h-5" />
//       </button>
//     </footer>
//   );
// };




// import React from 'react';
// import { NRLogo } from './NRLogo';
// import { Facebook, Twitter, Instagram, Linkedin, ArrowUp } from 'lucide-react';
// import { FaWhatsapp } from "react-icons/fa";

// export const Footer = () => {
//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth'
//     });
//   };

//   // تحديث المجالات لتعكس الخدمات التجارية والاستثمارية الفعلية للشركة
//   const legalAreas = [
//     'القانون التجاري وحوكمة الشركات',
//     'تأسيس الشركات الكبرى والناشئة',
//     'المستثمرين الأجانب والإقامة المميزة',
//     'الدعاوى والنزاعات العقارية',
//     'الأنظمة العمالية وعقود العمل',
//     'الدعاوى الإدارية وديوان المظالم'
//   ];

//   const quickLinks = [
//     { name: 'الرئيسية', href: '#hero' },
//     { name: 'خدماتنا القانونية', href: '#services' },
//     { name: 'عن الشركة', href: '#about' },
//     { name: 'فريق العمل', href: '#attorneys' },
//     { name: 'اتصل بنا', href: '#contact' }
//   ];

//   // دالة تمرير ناعمة تأخذ بعين الاعتبار ارتفاع الهيدر
//   const handleScroll = (e, href) => {
//     e.preventDefault();
//     const target = document.querySelector(href);
//     if (target) {
//       const offset = document.querySelector('header')?.offsetHeight || 0;
//       window.scrollTo({
//         top: target.offsetTop - offset,
//         behavior: 'smooth'
//       });
//     }
//   };

//   return (
//     // ضبط أرضية التذييل لتكون باللون الرمادي الناعم والنظيف المتناسق مع النمط الفاتح
//     <footer className="bg-slate-50 text-slate-600 border-t border-slate-200" dir="rtl">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          
//           {/* العمود الأول: الشعار والوصف العام وقنوات التواصل */}
//           <div className="space-y-6">
//             <div className="flex items-center gap-3">
//               {/* تفعيل اللون الكحلي الفاخر للشعار المتناسق مع البراند الجديد */}
//               <NRLogo color="#1e1b4b" /> 
//               <span className="text-base md:text-lg font-extrabold leading-tight text-indigo-950">  
//                 شركة ناصر الراجحي ورامي المطيري للمحاماة والاستشارات القانونية
//               </span>
//             </div>
//             <p className="text-slate-500 text-sm md:text-base font-light leading-relaxed">
//               شركة مهنية رائدة تقدم خدمات وقائية وقضائية متكاملة لحماية حقوقك ومصالح أعمالك بأعلى مستويات الموثوقية والحوكمة.
//             </p>
//             <div className="flex items-center gap-3 justify-start">
//               <a href="#" className="p-2.5 bg-white border border-slate-200 rounded-xl text-slate-400 hover:text-indigo-950 hover:border-indigo-950/20 shadow-sm transition-all duration-300" aria-label="Facebook">
//                 <Facebook className="w-4 h-4" />
//               </a>
//               <a href="#" className="p-2.5 bg-white border border-slate-200 rounded-xl text-slate-400 hover:text-indigo-950 hover:border-indigo-950/20 shadow-sm transition-all duration-300" aria-label="Twitter">
//                 <Twitter className="w-4 h-4" />
//               </a>
//               <a href="#" className="p-2.5 bg-white border border-slate-200 rounded-xl text-slate-400 hover:text-indigo-950 hover:border-indigo-950/20 shadow-sm transition-all duration-300" aria-label="Instagram">
//                 <Instagram className="w-4 h-4" />
//               </a>
//               <a href="#" className="p-2.5 bg-white border border-slate-200 rounded-xl text-slate-400 hover:text-indigo-950 hover:border-indigo-950/20 shadow-sm transition-all duration-300" aria-label="LinkedIn">
//                 <Linkedin className="w-4 h-4" />
//               </a>
//             </div>
//           </div>

//           {/* العمود الثاني: مجالات الممارسة المحدثة نصوصها باللون الكحلي والداكن */}
//           <div>
//             <h3 className="text-base font-bold text-indigo-950 mb-6 relative pb-2 after:content-[''] after:absolute after:bottom-0 after:right-0 after:w-8 after:h-0.5 after:bg-indigo-950">
//               مجالات ممارستنا
//             </h3>
//             <ul className="space-y-3">
//               {legalAreas.map((area, index) => (
//                 <li key={index}>
//                   <a href="#services" onClick={(e) => handleScroll(e, '#services')} className="text-slate-500 hover:text-indigo-950 transition-colors duration-200 text-sm font-light flex items-center gap-1.5">
//                     <span className="text-indigo-950/30 text-xs">▪</span>
//                     {area}
//                   </a>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* العمود الثالث: الروابط السريعة للتنقل الداخلي */}
//           <div>
//             <h3 className="text-base font-bold text-indigo-950 mb-6 relative pb-2 after:content-[''] after:absolute after:bottom-0 after:right-0 after:w-8 after:h-0.5 after:bg-indigo-950">
//               روابط سريعة
//             </h3>
//             <ul className="space-y-3">
//               {quickLinks.map((link, index) => (
//                 <li key={index}>
//                   <a 
//                     href={link.href} 
//                     className="text-slate-500 hover:text-indigo-950 transition-colors duration-200 text-sm font-light flex items-center gap-1.5"
//                     onClick={(e) => handleScroll(e, link.href)}
//                   >
//                     <span className="text-indigo-950/30 text-xs">▪</span>
//                     {link.name}
//                   </a>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* العمود الرابع: الاشتراك البريدي المحدث بنظام الـ Navy Light الفاخر */}
//           <div>
//             <h3 className="text-base font-bold text-indigo-950 mb-6 relative pb-2 after:content-[''] after:absolute after:bottom-0 after:right-0 after:w-8 after:h-0.5 after:bg-indigo-950">
//               النشرة المستندية
//             </h3>
//             <p className="text-slate-500 text-sm font-light leading-relaxed mb-4">
//               اشترك في القائمة البريدية للمكتب لتلقي أحدث التحديثات والتحليلات للأنظمة واللوائح الصادرة حديثاً.
//             </p>
//             <form onSubmit={(e) => e.preventDefault()} className="flex gap-2">
//               <input 
//                 type="email" 
//                 placeholder="البريد الإلكتروني" 
//                 required
//                 className="px-4 py-2.5 bg-white text-slate-900 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-950/10 focus:border-indigo-950 w-full text-sm shadow-sm"
//               />
//               <button 
//                 type="submit" 
//                 className="bg-indigo-950 hover:bg-indigo-900 text-white font-bold px-5 rounded-xl transition-all duration-300 text-sm whitespace-nowrap shadow-sm"
//               >
//                 اشتراك
//               </button>
//             </form>
//           </div>
//         </div>

//         {/* الخط الفاصل السفلي النظيف */}
//         <div className="border-t border-slate-200 my-10"></div>

//         {/* الحقوق والروابط القانونية */}
//         <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs md:text-sm text-slate-400 font-light">
//           <p className="text-center md:text-right">
//             © {new Date().getFullYear()} شركة ناصر الراجحي ورامي المطيري للمحاماة والاستشارات القانونية. جميع الحقوق محفوظة.
//           </p>
//           <div className="flex gap-6">
//             <a href="#" className="hover:text-indigo-950 transition-colors">سياسة الخصوصية</a>
//             <a href="#" className="hover:text-indigo-950 transition-colors">الشروط والأحكام</a>
//           </div>
//         </div>
//       </div>

//       {/* زر العودة للأعلى العائم المحدث متوافقاً مع الهوية الفاتحة */}
//       <button 
//         onClick={scrollToTop} 
//         className="fixed bottom-6 left-6 z-40 bg-white hover:bg-indigo-950 border border-slate-200 hover:border-indigo-950 text-slate-600 hover:text-white p-3 rounded-xl shadow-xl backdrop-blur-md transition-all duration-300 transform hover:-translate-y-1"
//         aria-label="Scroll to top"
//       >
//         <ArrowUp className="w-5 h-5" />
//       </button>

//       {/* زر الواتساب الرسمي العائم بتأثير متوهج مرن ونظيف */}
//       <button 
//         onClick={() => window.open('https://wa.me/966595014100', '_blank')} 
//         className="fixed bottom-6 right-6 z-40 bg-emerald-600 hover:bg-emerald-500 text-white p-3 rounded-xl shadow-xl shadow-emerald-600/10 backdrop-blur-md transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center"
//         aria-label="Contact via WhatsApp"
//       >
//         <FaWhatsapp className="w-5 h-5" />
//       </button>
//     </footer>
//   );
// };





import React from 'react';
import { NRLogo } from './NRLogo';
import { Facebook, Twitter, Instagram, Linkedin, ArrowUp } from 'lucide-react';
import { FaWhatsapp } from "react-icons/fa";

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const legalAreas = [
    { name: 'القانون التجاري وحوكمة الشركات', hash: '#services' },
    { name: 'تأسيس الشركات الكبرى والناشئة', hash: '#services' },
    { name: 'المستثمرين الأجانب والإقامة المميزة', hash: '#services' },
    { name: 'الدعاوى والنزاعات العقارية', hash: '#services' },
    { name: 'الأنظمة العمالية وعقود العمل', hash: '#services' },
    { name: 'الدعاوى الإدارية وديوان المظالم', hash: '#services' }
  ];

  const quickLinks = [
    { name: 'الرئيسية', hash: '#hero' },
    { name: 'خدماتنا القانونية', hash: '#services' },
    { name: 'عن الشركة', hash: '#about' },
    { name: 'فريق العمل', hash: '#attorneys' },
    { name: 'اتصل بنا', hash: '#contact' }
  ];

  // دالة الفحص والتوجيه الذكي عبر الصفحات والأقسام
  const handleScrollOrRedirect = (e, targetHash) => {
    // التحقق مما إذا كنا في الصفحة الرئيسية (سواء كانت "/" أو فارغة)
    const isMainPage = window.location.pathname === '/' || window.location.pathname === '/index.html';

    if (isMainPage) {
      // منع السلوك الافتراضي والتمرير ناعم داخل الصفحة الرئيسية
      e.preventDefault();
      const targetElement = document.querySelector(targetHash);
      if (targetElement) {
        const offset = document.querySelector('header')?.offsetHeight || 0;
        window.scrollTo({
          top: targetElement.offsetTop - offset,
          behavior: 'smooth'
        });
        // تحديث الهيدر في الرابط لتجنب الخلط البصري دون إعادة تحميل
        window.history.pushState(null, '', targetHash);
      }
    } else {
      // إذا كنا في صفحة فرعية، نترك الرابط يتوجه طبيعياً إلى الصفحة الرئيسية مع الهاش (مثال: /#services)
    }
  };

  return (
    <footer className="bg-slate-50 text-black border-t border-slate-200" dir="rtl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          
          {/* العمود الأول: الشعار والوصف العام وقنوات التواصل */}
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <NRLogo color="#1e1b4b" /> 
              <span className="text-base md:text-lg font-extrabold leading-tight text-indigo-950">  
                شركة ناصر الراجحي ورامي المطيري للمحاماة والاستشارات القانونية
              </span>
            </div>
            <p className="text-black text-sm md:text-base font-light leading-relaxed">
              شركة مهنية رائدة تقدم خدمات وقائية وقضائية متكاملة لحماية حقوقك ومصالح أعمالك بأعلى مستويات الموثوقية والحوكمة.
            </p>
            <div className="flex items-center gap-3 justify-start">
              <a href="#" className="p-2.5 bg-white border border-slate-200 rounded-xl text-slate-400 hover:text-indigo-950 hover:border-indigo-950/20 shadow-sm transition-all duration-300" aria-label="Facebook">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="p-2.5 bg-white border border-slate-200 rounded-xl text-slate-400 hover:text-indigo-950 hover:border-indigo-950/20 shadow-sm transition-all duration-300" aria-label="Twitter">
                <Twitter className="w-4 h-4" />
              </a>
              <a href="#" className="p-2.5 bg-white border border-slate-200 rounded-xl text-slate-400 hover:text-indigo-950 hover:border-indigo-950/20 shadow-sm transition-all duration-300" aria-label="Instagram">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="p-2.5 bg-white border border-slate-200 rounded-xl text-slate-400 hover:text-indigo-950 hover:border-indigo-950/20 shadow-sm transition-all duration-300" aria-label="LinkedIn">
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* العمود الثاني: مجالات الممارسة */}
          <div>
            <h3 className="text-base font-bold text-indigo-950 mb-6 relative pb-2 after:content-[''] after:absolute after:bottom-0 after:right-0 after:w-8 after:h-0.5 after:bg-indigo-950">
              مجالات ممارستنا
            </h3>
            <ul className="space-y-3">
              {legalAreas.map((area, index) => (
                <li key={index}>
                  <a 
                    href={`/${area.hash}`} 
                    onClick={(e) => handleScrollOrRedirect(e, area.hash)} 
                    className="text-black hover:text-indigo-950 transition-colors duration-200 text-sm font-light flex items-center gap-1.5"
                  >
                    <span className="text-indigo-950/30 text-xs">▪</span>
                    {area.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* العمود الثالث: الروابط السريعة */}
          <div>
            <h3 className="text-base font-bold text-indigo-950 mb-6 relative pb-2 after:content-[''] after:absolute after:bottom-0 after:right-0 after:w-8 after:h-0.5 after:bg-indigo-950">
              روابط سريعة
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a 
                    href={`/${link.hash}`} 
                    className="text-black hover:text-indigo-950 transition-colors duration-200 text-sm font-light flex items-center gap-1.5"
                    onClick={(e) => handleScrollOrRedirect(e, link.hash)}
                  >
                    <span className="text-indigo-950/30 text-xs">▪</span>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* العمود الرابع: الاشتراك البريدي */}
          <div>
            <h3 className="text-base font-bold text-indigo-950 mb-6 relative pb-2 after:content-[''] after:absolute after:bottom-0 after:right-0 after:w-8 after:h-0.5 after:bg-indigo-950">
              النشرة المستندية
            </h3>
            <p className="text-black text-sm font-light leading-relaxed mb-4">
              اشترك في القائمة البريدية للمكتب لتلقي أحدث التحديثات والتحليلات للأنظمة واللوائح الصادرة حديثاً.
            </p>
            <form onSubmit={(e) => e.preventDefault()} className="flex gap-2">
              <input 
                type="email" 
                placeholder="البريد الإلكتروني" 
                required
                className="px-4 py-2.5 bg-white text-slate-900 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-950/10 focus:border-indigo-950 w-full text-sm shadow-sm"
              />
              <button 
                type="submit" 
                className="bg-indigo-950 hover:bg-indigo-900 text-white font-bold px-5 rounded-xl transition-all duration-300 text-sm whitespace-nowrap shadow-sm"
              >
                اشتراك
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-slate-200 my-10"></div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs md:text-sm text-slate-400 font-light">
          <p className="text-center md:text-right">
            © {new Date().getFullYear()} شركة ناصر الراجحي ورامي المطيري للمحاماة والاستشارات القانونية. جميع الحقوق محفوظة.
          </p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-indigo-950 transition-colors">سياسة الخصوصية</a>
            <a href="#" className="hover:text-indigo-950 transition-colors">الشروط والأحكام</a>
          </div>
        </div>
      </div>

      <button 
        onClick={scrollToTop} 
        className="fixed bottom-6 left-6 z-40 bg-white hover:bg-indigo-950 border border-slate-200 hover:border-indigo-950 text-slate-600 hover:text-white p-3 rounded-xl shadow-xl backdrop-blur-md transition-all duration-300 transform hover:-translate-y-1"
        aria-label="Scroll to top"
      >
        <ArrowUp className="w-5 h-5" />
      </button>

      <button 
        onClick={() => window.open('https://wa.me/966595014100', '_blank')} 
        className="fixed bottom-6 right-6 z-40 bg-emerald-600 hover:bg-emerald-500 text-white p-3 rounded-xl shadow-xl shadow-emerald-600/10 backdrop-blur-md transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center"
        aria-label="Contact via WhatsApp"
      >
        <FaWhatsapp className="w-5 h-5" />
      </button>
    </footer>
  );
};